export const THEME_STORAGE_KEY = 'stratagen-theme';

export type ThemeMode = 'light' | 'dark';

export function isDarkMode(): boolean {
  return document.documentElement.classList.contains('dark');
}

export function getStoredTheme(): ThemeMode | null {
  try {
    const value = localStorage.getItem(THEME_STORAGE_KEY);
    if (value === 'dark' || value === 'light') return value;
  } catch {
    // ignore
  }
  return null;
}

export function applyTheme(mode: ThemeMode): void {
  const root = document.documentElement;
  if (mode === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

export function setTheme(mode: ThemeMode): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, mode);
  } catch {
    // ignore
  }
  applyTheme(mode);
}

/** Run once before first paint so the shell matches the saved or system preference. */
export function initTheme(): void {
  const stored = getStoredTheme();
  if (stored) {
    applyTheme(stored);
    return;
  }
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  applyTheme(prefersDark ? 'dark' : 'light');
}
